
export default function BenefitsSection() {
  const benefits = [
    {
      icon: '📈',
      title: '+20 à +30% de chiffre d\'affaires',
      description: 'Augmentation garantie de vos revenus mensuels',
      explanation: 'Des ventes supplémentaires chaque jour grâce à vos marques virtuelles qui attirent de nouveaux clients',
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      icon: '✅',
      title: '0€ d\'investissement',
      description: 'Aucun coût, aucun risque financier',
      explanation: 'Vous ne payez rien, nous nous rémunérons uniquement avec vos ventes supplémentaires',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      icon: '🚀',
      title: 'Plus de visibilité',
      description: 'Multipliez votre présence sur les plateformes',
      explanation: 'Votre restaurant devient 3 établissements différents, triplant vos chances d\'être commandé',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      icon: '🎯',
      title: 'Gestion complète par VirtualEat',
      description: 'Nous nous occupons de tout, vous cuisinez',
      explanation: 'Photos, descriptions, gestion des commandes : nous gérons tout pendant que vous vous concentrez sur la cuisine',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    },
    {
      icon: '🍔',
      title: 'Nouvelles ventes quotidiennes',
      description: 'Des commandes supplémentaires chaque jour',
      explanation: 'En moyenne 15-25 commandes supplémentaires par semaine grâce à vos nouvelles marques',
      color: 'text-red-600',
      bgColor: 'bg-red-100'
    }
  ];

  return (
    <section className="py-20 bg-gray-900 text-white relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Pourquoi choisir <span className="text-[#9EFD38]">VirtualEat</span> ?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Des résultats concrets, mesurables et sans risque
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white text-gray-900 p-8 rounded-2xl hover:scale-105 transition-transform duration-300 relative border-4 border-transparent hover:border-[#9EFD38]">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">{benefit.icon}</div>
              </div>
              <h3 className="text-xl font-bold mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {benefit.description}
              </p>
              <div className="border-t border-gray-200 pt-4">
                <p className="text-sm text-gray-500 italic">
                  → {benefit.explanation}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-[#9EFD38] text-black p-8 rounded-2xl max-w-4xl mx-auto relative border-4 border-black shadow-2xl">
            <h3 className="text-2xl md:text-3xl font-bold mb-4 mt-4">
              🚀 Résultats typiques de nos clients
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-black text-[#9EFD38] p-4 rounded-xl">
                <div className="text-3xl font-bold">+37%</div>
                <p className="font-semibold">Augmentation moyenne des ventes</p>
              </div>
              <div className="bg-black text-[#9EFD38] p-4 rounded-xl">
                <div className="text-3xl font-bold">€0</div>
                <p className="font-semibold">Investissement requis</p>
              </div>
              <div className="bg-black text-[#9EFD38] p-4 rounded-xl">
                <div className="text-3xl font-bold">30j</div>
                <p className="font-semibold">Temps moyen pour voir les résultats</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
